module.exports = __webpack_public_path__ + "img/CAL-UHF-S.806ae8625503f25f59fd51b88bf0d740.avif";